import { FC, useEffect } from 'react'
import { isOpenFinRuntime } from '../../containers/OpenFin/helpers'
import {
  benchmarkDataFetch,
  unsubscribeFromBenchmark
} from '../../store/benchmarkData/actions'
import {
  getBenchmarkData,
  getBenchmarkDataPending
} from '../../store/benchmarkData/selectors'
import { useAppDispatch, useAppSelector } from '../../store/types'
import Loading from '../Loading/Loading'
import BenchmarkData from './BenchmarkData'

const BenchmarkContainer: FC = () => {
  const dispatch = useAppDispatch()
  const pending = useAppSelector(getBenchmarkDataPending)
  const isOpenFin = isOpenFinRuntime()
  useEffect(() => {
    dispatch(benchmarkDataFetch())
    return () => {
      dispatch(unsubscribeFromBenchmark())
    }
  }, [])
  const benchmarkData = useAppSelector(getBenchmarkData)
  if (isOpenFin && (pending || !benchmarkData)) return <Loading />
  if (!benchmarkData) return null

  return <BenchmarkData benchmarkData={benchmarkData} />
}

export default BenchmarkContainer
